import { Component, OnInit, ViewChild } from '@angular/core';
import { ShipService } from '../../services/ship.service';
import { Ship } from '../../Ship';
import { ShipRoundTripHistory } from '../../data/ShipRoundTripHistory';
import { Router } from '@angular/router';
import { RoundTripHistoryComponent } from './round-trip-history/round-trip-history.component';
import { FleetInformationComponent } from './fleet-information/fleet-information.component';
import { RoundTripOverviewComponent } from './round-trip-overview/round-trip-overview.component';
import {ShipInstallation} from '../../data/ShipInstallation';
import {EomReportDetails} from '../../data/EomReportDetails';

@Component({
  selector: 'app-round-trips',
  templateUrl: './round-trips.component.html',
  styleUrls: ['./round-trips.component.css']
})
export class RoundTripsComponent implements OnInit {
  @ViewChild('roundTripHistory', { static: false })
  roundTripHistory: RoundTripHistoryComponent;
  @ViewChild('fleetInformation', { static: false })
  fleetInformation: FleetInformationComponent;
  @ViewChild('roundTripOverview', { static: false })
  roundTripOverview: RoundTripOverviewComponent;
  ship: Ship;
  shipResultArray: Ship[];
  shipRoundTripHistory: ShipRoundTripHistory;
  shipInstallations: ShipInstallation[];
  lastEOMDetails: EomReportDetails[];

  constructor(private shipService: ShipService, private router: Router) {}

  ngOnInit() {
    this.ship = this.shipService.retrieveShipProfile();
    this.shipResultArray = this.shipService.retieveAllShipProfileResults();
    if (this.ship == null) {
      this.router.navigate(['/shipProfiles']);
    }
    this.shipService.getLastSeen(this.ship.shipLocation).subscribe(
      (data: ShipInstallation[]) => {
        this.shipInstallations = data.sort((a, b) => (a.lastSeen && b.lastSeen) ?
          b.lastSeen.localeCompare(a.lastSeen) :
          (a.lastSeen ? -1 : b.lastSeen ? 1 : a.hostName.localeCompare(b.hostName)));
      },
      (error) => { console.log('There was a problem getting Tablet Connection Status: ' + error); },
      () => {}
    );
    this.shipService.getLastEOM(this.ship.shipLocation).subscribe(
      (data: EomReportDetails[]) => {
        this.lastEOMDetails = data;
      },
      (error) => {
        console.log(
          'There was a problem getting the last EOM Report details: ' + error
        )
      },
      () => {}
    );
    this.shipService.getShipRoundTripHistory(this.ship.shipLocation).subscribe(
      (data: ShipRoundTripHistory) => {
        this.shipRoundTripHistory = data;
      },
      (error) => {
        console.log(
          'There was a problem getting Ship Round Trip History: ' + error
        );
      },
      () => {}
    );
  }

  onShipChange(newShip: Ship) {
    this.ship = newShip;
    this.shipService.storeShipProfile(this.ship);
    this.shipService.getShipRoundTripHistory(this.ship.shipLocation).subscribe(
      (data: ShipRoundTripHistory) => {
        this.shipRoundTripHistory = data;
      },
      (error) => { console.log('There was a problem getting Ship Round Trip History: ' + error); },
      () => {
        this.fleetInformation.updateShipData(this.ship);
        this.roundTripHistory.updateShipData(this.ship, this.shipRoundTripHistory, this.shipInstallations);
        this.roundTripOverview.updateShipData(this.ship, this.shipRoundTripHistory, this.shipInstallations);
      }
    );
  }


}
